import React from "react";
import {
  Button,
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {
  AddCircle,
  FeaturedPlayList
} from "@mui/icons-material";
import {useSelector} from "react-redux";
import rateConvert from "../../../../../utils/rateConvert";
import {Link} from "react-router-dom";
import getTrans from "../../../../../languages/getTrans";

const BalanceInfo = () => {
  const classes = useStyles();
  const balance = useSelector(state => state.profile?.balance || 0);

  return (
    <>
      <div className={classes.title}>{getTrans('balanceInfo.Ваш баланс')}</div>
      <div className={classes.balance}>
        {rateConvert(balance, {useSybmol: true, decimalCount: 'auto'})}
        <Button variant="contained" component={Link} to="/top-up-balance">
          {getTrans('balanceInfo.Пополнить')}
          <AddCircle sx={{color: 'white', fontSize: 16, marginLeft: "6px"}}/>
        </Button>
      </div>
      <Button fullWidth className={classes.balanceHistory} component={Link} to="/balance-history">
        {getTrans('balanceInfo.История баланса')}
        <FeaturedPlayList sx={{fontSize: 20}}/>
      </Button>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  title: {
    opacity: "0.5",
    marginBottom: "4px",

    fontSize: 15,
    color: "white",
    lineHeight: "18px"
  },
  balance: {
    height: 40,
    display: "flex",
    borderRadius: "8px",
    alignItems: "center",
    background: "#FFFFFF0D",
    boxSizing: "border-box",
    padding: "5px 8px",
    paddingRight: "5px",
    border: "1px solid #FFFFFF1A",

    fontSize: 18,
    color: "white",
    fontWeight: "500",
    lineHeight: "22px",

    "& .MuiButtonBase-root": {
      marginLeft: "auto"
    }
  },
  balanceHistory: {
    gap: "8px",
    height: 40,
    display: "flex",
    marginTop: "8px",
    alignItems: "center",
    justifyContent: "center",
    background: "#FB780033!important",

    fontSize: 15,
    color: "white",
    lineHeight: "18px"
  },
}))

export default BalanceInfo
